export default "data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAABQAgCdASpAADAAAAAAJYwAA8llXTftYs2Ph4AA/v/e3PKj//6dyB///Yzf/9GV///5ZL///K+AAAAA"